import { building } from '$app/env'
import { PUBLIC_DB_MAINTENANCE } from '$app/env/public'

export const inMaintenanceMode = () =>
  !building && PUBLIC_DB_MAINTENANCE === 'true'
